import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  salesConceptCategoryId: string;
  body: {
    id: string;
    displayOrder: number;
  }[];
};

const request = ({ salesConceptCategoryId, body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(
      `/api/managers/sales_concept_categories/${salesConceptCategoryId}/display_order`,
      {
        salesConceptCategory: { salesConcepts: body },
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersSalesConceptCategoriesDisplayOrdersUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
